const DEFAULT_TEXT_MIME_TYPE = "text/plain;charset=utf-8";
const UTF8_BOM = "\uFEFF";

export interface DownloadTextOptions {
  includeBom?: boolean;
  mimeType?: string;
}

export class FileDownloadService {
  downloadText(fileName: string, content: string, options: DownloadTextOptions = {}): void {
    const mimeType = options.mimeType ?? DEFAULT_TEXT_MIME_TYPE;
    const blob = new Blob([options.includeBom ? UTF8_BOM : "", content], { type: mimeType });

    this.downloadBlob(fileName, blob);
  }

  downloadBlob(fileName: string, blob: Blob): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}

const fileDownloadService = new FileDownloadService();

export { fileDownloadService };
